// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2M91r","footer":"styles_footer__2YBpk","passCodeTooltip":"styles_passCodeTooltip__3bNUc"};